import { ApplicationInsights, SeverityLevel } from '@microsoft/applicationinsights-web';

let appInsights: ApplicationInsights | undefined;

export const setAppInsights = (instance: ApplicationInsights): void => {
  appInsights = instance;
};

export const trackWarning = (
  message: string,
  properties?: { [key: string]: string | number },
): void => {
  appInsights?.trackTrace({ message, severityLevel: SeverityLevel.Warning }, properties);
};
